import { render, staticRenderFns } from "./TrunkComparisonModal.vue?vue&type=template&id=4c7e85a0&scoped=true&"
import script from "./TrunkComparisonModal.vue?vue&type=script&lang=js&"
export * from "./TrunkComparisonModal.vue?vue&type=script&lang=js&"
import style0 from "./TrunkComparisonModal.vue?vue&type=style&index=0&id=4c7e85a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7e85a0",
  null
  
)

export default component.exports